import React, { useEffect, useState, useContext, useRef } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
  Link,
} from "react-router-dom";
import { LogoBackground, Seal, Button, Loader } from "components";
import { ContextData } from "data/Context";
import { useStateWithValidation } from "hooks";
import GGCStoreFront from "services/ggc-storefront-api";
import QRCode from "react-qr-code";

const emailRegEx: any =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const numberRegEx: any =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export default function Checkout() {
  const [processing, startProcessing]: any = useState(false);
  const [orderNumber, setorderNumber]: any = useState(false);
  const [errMsg, setErrMsg]: any = useState("");
  const [shopifyModel, setShopifyModel]: any = useState(false);
  const [waitTime, setWaitTime]: any = useState(false);

  const textInput = useRef(null);
  const phoneNumberInput = useRef(null);
  const emailInput = useRef(null);
  const emailMarketingCheckbox = useRef(null);

  const [name, setName]: any = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const [PhoneNumber, setPhoneNumber, PhoneNumberIsVaild] =
    useStateWithValidation((number: any) => {
      if (numberRegEx.test(number)) {
        return true;
      } else {
        return false;
      }
    }, false);

  const [Email, setEmail, EmailIsVaild] = useStateWithValidation(
    (email: any) => {
      if (emailRegEx.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    false
  );
  const [emailMarketing, setEmailMarketing] = useState(false);

  const contextReact = useContext(ContextData);
  let history = useHistory();

  const createCustomer = () => {
    contextReact.updater("isFetching", true);
    GGCStoreFront.getInstance().addCustomer(
      name.length ? name.split(" ").slice(0, -1).join(" ") : name,
      name.length ? name.split(" ").slice(-1).join(" ") : "",
      EmailIsVaild ? Email : "",
      PhoneNumberIsVaild ? PhoneNumber : "",
      emailMarketingCheckbox.current.value === "on",
      () => {
        history.push("/Checkout/Card");
        contextReact.updater("isFetching", false);
      }
    );
  };

  useEffect(() => {
    if (window.location.pathname === "/Checkout/Finished/") {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      setorderNumber(urlParams.get("v"));
      console.log(orderNumber);

      setTimeout(() => {
        if (window.location.pathname === "/Checkout/Finished/") {
          history.push("/");
          //window.location.href = "/";
        }
      }, 30000);
    }
    if (window.location.pathname === "/Checkout/Error/") {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      setErrMsg(urlParams.get("msg"));
    }
    if (window.location.pathname === "/Checkout/Card") {
      GGCStoreFront.getInstance().initializeStripe(() => {
        GGCStoreFront.getInstance()
          .connectCardReader()
          .then(() => {
            GGCStoreFront.getInstance().collectPayment((success, error) => {
              console.log(`Payment successful? ${success}`);
              if (success) {
                history.push(
                  `/Checkout/Finished/?v=${GGCStoreFront.getInstance().Cart.id}`
                );
                contextReact.flushCart();
                contextReact.updater("swiperStep", 1);
                setTimeout(() => {
                  contextReact.updateCartCount();
                }, 100);
              } else {
                history.push(`/Checkout/Error/?msg=${error}`);
              }
            });
          });
      });
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (textInput.current) {
      setName(textInput.current.value);
    }

    fetch("https://justfields.com/project/G46B7kr8/json")
      .then((response) => response.json())
      .then(function (data) {
        setWaitTime(data.group_1.time.split(" ")[0]);
        console.log(data.group_1.time);
      })
      .catch((error) => {
        setWaitTime(10);
      });
  }, []);

  return (
    <div className="checkout-con">
      <LogoBackground />

      <Switch>
        <Route path="/Checkout/Finished">
          <div>
            <div className="checkout-inner --placed">
              <h1 className="checkout-title">
                THANK YOU for placing an order!
              </h1>
              <span className="checkout-orderNumber">
                Order Number: GG{orderNumber}
              </span>
              <p className="checkout-copy --smaller">
                Yay, your custom Goo Goo has been sent to the candy kitchen for
                creation! A team member will call out your Goo Goo’s name when
                it is complete. Since each Premium is handmade, now you have
                some time to explore the store or create another Premium
                &nbsp;Goo&nbsp;Goo.
              </p>
              <h3 className="checkout-titleH3">Average Wait Time </h3>
              <Seal size="--smallNumber --bigMobile">
                {waitTime ? waitTime : <Loader />}
              </Seal>
              <div className="checkout-minutes">Minutes</div>
            </div>
            <Button
              big={true}
              text=" Make Another"
              passClick={() => {
                history.push("/");
              }}
            ></Button>
          </div>
        </Route>

        <Route path="/Checkout/Error">
          <div>
            <div className="checkout-inner --placed">
              <h1 className="checkout-title">
                oops, sorry for <br /> the trouble.
              </h1>
              <span className="checkout-orderNumber"></span>
              <p className="checkout-copy --smaller">{errMsg}</p>

              <br />
              <Link to="/Checkout" className="checkout-link">
                Try again?
              </Link>
              <Link to="/Checkout/shopify" className="checkout-link">
                Input payment information manually?
              </Link>
            </div>
          </div>
        </Route>

        <Route path="/Checkout/Cancel">
          <div>
            <div className="checkout-inner --placed">
              <h1 className="checkout-title">Cancelling order</h1>
              <span className="checkout-orderNumber"></span>
              <p className="checkout-copy --smaller">{errMsg}</p>
              <Loader />
              <br />
              Please wait...
            </div>
          </div>
        </Route>

        <Route path="/Checkout/shopify">
          <div className="checkout-inner">
            <h1 className="checkout-title">scan the code</h1>
            <p className="checkout-copy --smaller">
              Point your phone camera at the QR code to open your personal
              payment link
            </p>
            <br />
            <br />
            <QRCode value={contextReact.shopifyCart?.invoiceUrl} />
            {/* <br /> */}
            <Button
              big={true}
              text="Make more"
              passClick={() => {
                contextReact.flushCart();
                contextReact.updater("swiperStep", 1);
                history.push("/");
                setTimeout(() => {
                  contextReact.updateCartCount();
                }, 100);
              }}
            ></Button>
          </div>
        </Route>

        <Route path="/Checkout/Card">
          {processing ? (
            <div className="checkout-inner">
              <h1
                className="checkout-title"
                style={{
                  padding: "0px",
                }}
              >
                processing payment
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </h1>
            </div>
          ) : (
            <div className="checkout-inner">
              {contextReact.isFetching ? (
                <>
                  <Loader />
                  Please wait...
                </>
              ) : (
                <>
                  <h1 className="checkout-title">
                    Please follow the instructions on the card reader.
                  </h1>
                  {/* <p className="checkout-copy --smaller">
                The system is having trouble reading your card. <br /> We’ve got
                some options…
              </p>
              <p className="checkout-copy">
                We can help. Notify one of our Team <br />
                Members for assistance.
              </p> */}
                  <svg
                    width="150"
                    height="90"
                    viewBox="0 0 150 90"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="checkout-cardIcon"
                  >
                    <path
                      d="M55.4876 88.8812C37.6066 87.3187 21.8318 80.6813 11.5506 70.4189C5.70072 64.569 2.15076 58.219 0.550777 50.7379C-0.186714 47.3379 -0.180464 41.688 0.550777 38.2568C2.782 27.8569 9.50692 18.757 20.088 11.8196C44.2253 -4.01146 81.1998 -3.93021 105.112 12.0071C108.287 14.1196 110.337 15.8008 113.212 18.632C116.837 22.2132 119.387 25.7694 122.074 31.0069C122.174 31.1944 122.668 31.4444 123.174 31.5444C124.862 31.8944 127.131 33.2193 128.949 34.9193C130.362 36.2318 131.455 37.6693 134.149 41.7505C136.868 45.8629 149.174 64.8565 149.924 66.1002C150.211 66.5877 149.636 67.3627 148.986 67.3627C148.53 67.3627 148.199 67.0502 147.524 65.9877L140.549 55.1628C128.674 36.7756 128.031 35.9256 124.724 34.2693L122.987 33.3943H117.881C112.781 33.3943 112.774 33.4006 112.649 33.9381C111.974 36.8756 111.849 37.6005 111.999 37.738C112.093 37.8255 114.987 39.4755 118.437 41.4005L124.699 44.913L124.312 45.7317C124.093 46.1817 123.849 46.5567 123.762 46.5567C123.674 46.5567 118.399 43.6317 112.043 40.063C105.681 36.5006 100.106 33.4756 99.6558 33.3506C97.8434 32.8506 95.0684 34.8506 95.0684 36.6568C95.0684 38.4818 95.6121 39.0193 106.781 48.1629C113.749 53.8753 117.737 57.3003 118.343 58.1128C119.456 59.5878 120.574 61.7628 121.612 64.4377C123.424 69.1502 126.381 71.7751 131.224 72.9876L132.818 73.3876L132.687 74.2626C132.65 74.5978 132.572 74.9273 132.455 75.2438C132.249 75.4751 129.037 74.4501 127.181 73.5564C124.274 72.1626 122.274 70.1751 120.312 66.7189C119.457 66.9759 118.613 67.2657 117.781 67.5877C115.337 68.4752 115.218 68.5502 112.906 70.8064C103.056 80.4188 88.931 86.5625 71.8687 88.6499C69.1 88.9937 58.4313 89.1437 55.4876 88.8812ZM72.4687 85.925C80.2936 84.8875 86.3622 83.3375 92.7184 80.7375C99.3871 78.0063 105.675 74.0814 110.074 69.9064L111.806 68.2564L107.443 66.1752C102.781 63.944 102.318 63.5752 101.725 61.5815C101.35 60.3315 101.775 58.9878 102.962 57.7003L103.893 56.6941L101.868 55.1566C100.268 53.9378 99.7683 53.4066 99.4558 52.5941C99.2104 51.9622 99.1269 51.2788 99.2132 50.6064C99.2994 49.9339 99.5526 49.2937 99.9496 48.7442L100.562 47.8817L94.1684 46.7567C91.7291 46.3494 89.2993 45.8868 86.881 45.3692C86.3497 45.1629 85.8746 44.834 85.4945 44.4094C85.1144 43.9847 84.8399 43.4763 84.6935 42.9255C84.556 42.3505 87.6935 27.0507 88.3935 24.8632C88.638 24.3003 89.0032 23.7981 89.4633 23.392C89.9233 22.9859 90.4671 22.6859 91.0559 22.5132C92.1122 22.3195 110.962 25.6319 111.899 26.1819C113.387 27.0444 113.856 28.4444 113.387 30.5881L113.187 31.4881H114.231C114.806 31.4881 116.168 31.4131 117.249 31.3319L119.224 31.1756L118.243 29.3631C115.281 23.8507 109.931 18.3133 103.318 13.9133C100.231 11.8634 93.6497 8.61964 89.6872 7.20091C83.5314 5.06775 77.1495 3.6542 70.6687 2.98846C67.075 2.61346 57.6563 2.61346 54.1689 2.99471C45.8002 3.9072 38.2066 5.80093 31.5629 8.63214C16.1881 15.1883 5.84446 26.0444 3.20075 38.4255C2.51325 41.6567 2.45075 47.3192 3.08825 50.2629C4.48823 56.7628 7.54444 62.394 12.5194 67.6377C22.6443 78.3063 38.1253 84.8625 56.6814 86.35C59.1626 86.5437 69.9374 86.2562 72.4687 85.925ZM69.075 74.2751C68.1187 74.0001 67.15 72.8564 66.95 71.7751C66.8125 71.0626 66.975 70.5751 67.9875 68.6127C72.0874 60.6753 73.8686 53.3816 73.8686 44.5192C73.8686 35.9568 72.2937 29.3006 68.375 21.3132C67.5312 19.6008 66.8437 18.007 66.8437 17.782C66.8437 16.932 67.5562 15.7008 68.325 15.2196C69.3812 14.5508 71.1499 14.6758 71.9999 15.4696C72.3249 15.7821 73.1687 17.1633 73.8749 18.557C76.6811 24.057 78.5998 30.1006 79.5498 36.3881C80.1373 40.2818 80.2561 47.6567 79.7873 51.2191C78.9995 57.5321 77.1838 63.6736 74.4124 69.4002C72.7249 72.8689 71.6749 74.3001 70.7874 74.3001C70.574 74.3054 70.362 74.3369 70.1562 74.3938C69.7914 74.43 69.4232 74.3896 69.075 74.2751ZM57.6626 68.3064C56.2001 67.8752 55.1376 66.0752 55.5626 64.7252C55.6689 64.4002 56.3564 62.894 57.1001 61.3815C60.1972 55.194 61.5149 48.268 60.9063 41.3755C60.3813 35.8381 59.3876 32.3444 56.8876 27.2319C55.2064 23.8007 55.1314 23.2695 56.1064 21.8945C57.0313 20.582 59.3501 20.3633 60.5626 21.482C61.4063 22.257 64.0313 27.7319 65.0375 30.8319C68.3854 41.11 67.8699 52.2563 63.5875 62.1815C61.3875 67.3439 59.8438 68.9377 57.6626 68.3064ZM45.9002 62.2502C45.432 62.0231 45.0193 61.696 44.691 61.2922C44.3628 60.8884 44.127 60.4175 44.0003 59.9128C43.869 59.3253 44.0878 58.6753 45.169 56.4941C49.1189 48.4942 49.1627 40.7818 45.294 32.9631C43.6003 29.5256 43.5628 28.8444 45.0002 27.4882C45.7065 26.8194 46.0065 26.7007 47.0002 26.7007C48.6689 26.7007 49.5377 27.5444 51.0252 30.6069C53.3189 35.3193 54.2626 39.4068 54.2501 44.6442C54.2501 50.0191 53.3689 53.7191 50.9189 58.6878C49.5127 61.5315 48.8189 62.2815 47.419 62.4752C46.9021 62.5214 46.3816 62.4443 45.9002 62.2502ZM34.9191 56.6128C34.07 56.1634 33.429 55.4014 33.1316 54.4878C32.8629 53.5378 33.0816 52.7816 34.1629 51.0066C35.5504 48.7254 35.8754 47.5067 35.8754 44.5192C35.8754 41.538 35.5504 40.313 34.1629 38.0318C33.7516 37.3794 33.4002 36.6912 33.1129 35.9756C32.6691 34.4756 33.9191 32.6319 35.6004 32.3131C37.0253 32.0444 38.0066 32.6881 39.3191 34.7318C41.1785 37.6841 42.1652 41.102 42.1652 44.5911C42.1652 48.0801 41.1785 51.4981 39.3191 54.4503C37.9753 56.5253 36.4816 57.2628 34.9191 56.6128ZM116.731 65.819C117.999 65.3627 119.099 64.9377 119.168 64.8627C119.243 64.794 118.999 63.9815 118.624 63.0565C117.862 61.169 117.987 61.2128 115.287 61.7315C112.362 62.294 110.668 61.794 107.474 59.444C106.6 58.8003 105.706 58.2753 105.475 58.2753C105.25 58.2753 104.756 58.6065 104.368 59.019C103.556 59.894 103.431 61.269 104.093 62.0815C104.675 62.7877 112.699 66.6064 113.656 66.6252C114.074 66.6377 115.462 66.2752 116.731 65.819ZM115.468 59.6753C116.656 59.4378 116.787 59.3565 116.581 58.9753C116.356 58.5503 105.256 49.3379 104.293 48.7754C103.5 48.3129 102.856 48.4192 102.2 49.1254C100.268 51.1879 100.493 51.6254 105.487 55.4566C111.512 60.069 112.149 60.344 115.468 59.6753ZM100.568 45.7317C100.568 45.6692 99.3121 44.588 97.7684 43.3255C93.9684 40.1943 93.1559 39.0255 93.1559 36.7131C93.1559 34.7756 94.4434 32.9131 96.5184 31.8381C97.7445 31.2879 99.1192 31.1626 100.425 31.4819C101.162 31.7194 104.475 33.5131 109.068 36.1568L110.037 36.7131L110.837 32.9256C111.649 29.0506 111.668 28.0382 110.912 27.8007C107.636 27.1738 104.355 26.5779 101.068 26.0132C91.8622 24.3882 90.8559 24.2945 90.4309 24.9882C90.1997 25.3632 86.6997 41.588 86.6997 42.2817C86.6997 42.6255 86.8747 43.0567 87.0872 43.2317C87.2997 43.413 90.2872 44.0567 93.7247 44.6692C100.362 45.8629 100.568 45.8942 100.568 45.7317Z"
                      fill="#3F281E"
                    />
                  </svg>
                  <Link
                    to="/Checkout/Cancel"
                    className="checkout-link"
                    onClick={async () => {
                      contextReact.updater("isFetching", true);
                      await GGCStoreFront.getInstance().cancelPayment(
                        GGCStoreFront.getInstance().paymentIntentID
                      );
                      contextReact.updater("isFetching", false);
                      contextReact.flushCart();
                      contextReact.updater("swiperStep", 1);
                      history.push("/");
                      setTimeout(() => {
                        contextReact.updateCartCount();
                      }, 100);
                    }}
                  >
                    Cancel Order
                  </Link>
                  <div
                    className="checkout-link"
                    onClick={async () => {
                      contextReact.updater("isFetching", true);
                      await GGCStoreFront.getInstance().cancelPayment(
                        GGCStoreFront.getInstance().paymentIntentID,
                        false
                      );
                      contextReact.updater("isFetching", false);
                      history.push("/Checkout/shopify");
                    }}
                  >
                    Input payment information manually?
                  </div>
                </>
              )}
            </div>
          )}
        </Route>
        <Route path="/">
          {contextReact.isFetching ? (
            <Loader />
          ) : (
            <div className="checkout-inner checkout-input">
              <h1 className="checkout-title">Digital receipt </h1>

              <p className="checkout-copy --smaller">
                Enter your name with your Email or Phone Number so we can send
                you a digital receipt.
              </p>
              <br />
              <div className="checkout-input-title">Name</div>
              <input
                name="name"
                type="text"
                placeholder="Enter your name"
                className="configurator-input"
                defaultValue={contextReact.shopifyCart?.lineItems?.[0]?.title}
                ref={textInput}
                onKeyUp={() => {
                  setName(textInput.current.value);

                  // console.log(
                  //   name.length ? name.split(" ").slice(0, -1).join(" ") : name
                  // );
                  // console.log(
                  //   name.length ? name.split(" ").slice(-1).join(" ") : ""
                  // );

                  // console.log(name.split(" ").slice(0, -1).join(" "));
                  // console.log(name.split(" ").slice(-1).join(" "));
                }}
              />
              <div className="checkout-input-flex">
                <div className="checkout-input-title">Phone Number</div>

                {!PhoneNumberIsVaild && PhoneNumber ? (
                  <div className="checkout-input-errorMsg">
                    {" "}
                    *Invalid Phone Number
                  </div>
                ) : (
                  ""
                )}
              </div>
              <input
                name="contact"
                autoComplete="off"
                type="text"
                placeholder="Enter Phone Number"
                className="configurator-input"
                ref={phoneNumberInput}
                onKeyUp={() => {
                  setIsFocused(true);
                  setPhoneNumber(phoneNumberInput.current.value);
                }}
                onBlur={() => {
                  setIsFocused(false);
                }}
                style={{
                  border:
                    !PhoneNumberIsVaild && PhoneNumber
                      ? "1px solid #E31B23"
                      : "",
                }}
              />
              <div className="checkout-input-flex">
                <div className="checkout-input-title">Email</div>
                {!EmailIsVaild && Email ? (
                  <div className="checkout-input-errorMsg"> *Invalid email</div>
                ) : (
                  ""
                )}
              </div>
              <input
                name="contact 2"
                autoComplete="off"
                type="text"
                placeholder="Enter Email "
                style={{
                  border: !EmailIsVaild && Email ? "1px solid #E31B23" : "",
                }}
                className="configurator-input"
                ref={emailInput}
                onKeyUp={() => {
                  setIsFocused(true);
                  setEmail(emailInput.current.value);
                }}
                onBlur={() => {
                  setIsFocused(false);
                }}
              />

              <div className="checkout-input-flex --center">
                <input
                  ref={emailMarketingCheckbox}
                  type="checkbox"
                  name="checkbox"
                  onChange={() => {
                    setEmailMarketing(emailMarketingCheckbox.current.value);
                  }}
                  className="checkout-input-checkbox"
                />
                <div className="checkout-input-title">
                  Receive future email marketing.
                </div>
              </div>

              <div className="configurator-buttonCon --inLine checkout-input">
                {/* <Link to="/Cart">
                <Button text={"back to cart"} left={true} />
              </Link> */}

                <Button
                  text="No receipt"
                  extraClass="--center"
                  center={true}
                  left={true}
                  passClick={() => {
                    history.push("/Checkout/Card");
                  }}
                />

                <Button
                  text={"Continue"}
                  disabled={
                    (PhoneNumberIsVaild && name) || (EmailIsVaild && name)
                      ? false
                      : true
                  }
                  passClick={() => {
                    createCustomer();
                  }}
                />
              </div>
            </div>
          )}
        </Route>
      </Switch>
    </div>
  );
}
